module.exports = __webpack_public_path__ + "media/images/mailbox-9ce0767a28cdaaf702b21725555324e3.svg";